import { Box, Flex, FormHeading, Text, Tooltip } from "atoms";
import { AmenitiesForm, SpecificationForm } from "molecules";

import React, { useMemo, useState } from "react";
import { PROPERTY_STATUS } from "utils/constants";

export const SpecificationAndAmenities = ({
  onNext,
  onPrevious,
  bindHitOnSave,
  fetchProperty,
  rootProperty,
}) => {
  const [type, setType] = useState(0);
  const tabs = useMemo(
    () => [
      {
        name: "Specification",
        status: true,
      },
      {
        name: "Amenities",
        status: rootProperty?.[PROPERTY_STATUS.specifications],
      },
    ],
    [rootProperty]
  );
  const [isActiveTab, setActiveTab] = useState("Specification");

  return (
    <Box style={{ overflowWrap: "anywhere" }}>
      <FormHeading text="Specification & Amenities" />
      <Flex
        alignItems="center"
        borderBottom=".5px solid"
        borderColor="neutral.200"
        mt="1.6rem"
      >
        {tabs.map((item, index) => (
          <Box key={index}>
            <Tooltip
              render={item?.status ? "" : `${tabs?.[index - 1]?.name} required`}
              maxWidth="none !important"
              isTooltipArrow
              // {...tooltipProps}
            >
              <Text
                color={type !== index ? "neutral.400" : "neutral.800"}
                fontFamily="NeometricBold"
                onClick={
                  item?.status
                    ? () => {
                        setType(index);
                        setActiveTab(item?.name);
                      }
                    : undefined
                }
                borderBottom={type === index ? "2px solid" : "none"}
                borderColor="secondary.700"
                p="1rem 1.8rem"
                cursor="pointer"
              >
                {item?.name}
              </Text>
            </Tooltip>
          </Box>
        ))}
      </Flex>
      {isActiveTab === "Specification" && (
        <SpecificationForm
          onNext={() => {
            // onNext();
            setType(1);
            setActiveTab("Amenities");
          }}
          onPrevious={onPrevious}
          bindHitOnSave={bindHitOnSave}
          fetchProperty={fetchProperty}
          rootProperty={rootProperty}
        />
      )}
      {isActiveTab === "Amenities" && (
        <AmenitiesForm
          onNext={onNext}
          onPrevious={onPrevious}
          bindHitOnSave={bindHitOnSave}
          fetchProperty={fetchProperty}
          rootProperty={rootProperty}
        />
      )}
    </Box>
  );
};
